import { colorScales } from "@octopusdeploy/design-system-tokens";
import { iconStyle, type LiveStatusIconSize } from "../LiveAppIcons";
export function UnknownIcon(size: LiveStatusIconSize) {
    return (<span role="img" className={iconStyle(size)} style={{ background: colorScales.grey[500] }}>
            <em className="fa-solid fa-question"/>
        </span>);
}
